// export const data = [
//   {
//     "country": "AD",
//     "hot dog": 142,
//     "hot dogColor": "hsl(275, 70%, 50%)",
//     "burger": 127,
//     "burgerColor": "hsl(257, 70%, 50%)",
//     "sandwich": 122,
//     "sandwichColor": "hsl(344, 70%, 50%)",
//     "kebab": 70,
//     "kebabColor": "hsl(2, 70%, 50%)",
//     "fries": 61,
//     "friesColor": "hsl(51, 70%, 50%)",
//     "donut": 86,
//     "donutColor": "hsl(167, 70%, 50%)"
//   },
//   {
//     "country": "AE",
//     "hot dog": 108,
//     "hot dogColor": "hsl(195, 70%, 50%)",
//     "burger": 105,
//     "burgerColor": "hsl(294, 70%, 50%)",
//     "sandwich": 22,
//     "sandwichColor": "hsl(354, 70%, 50%)",
//     "kebab": 139,
//     "kebabColor": "hsl(236, 70%, 50%)",
//     "fries": 170,
//     "friesColor": "hsl(346, 70%, 50%)",
//     "donut": 152,
//     "donutColor": "hsl(157, 70%, 50%)"
//   },
//   {
//     "country": "AF",
//     "hot dog": 30,
//     "hot dogColor": "hsl(295, 70%, 50%)",
//     "burger": 31,
//     "burgerColor": "hsl(94, 70%, 50%)",
//     "sandwich": 111,
//     "sandwichColor": "hsl(77, 70%, 50%)",
//     "kebab": 124,
//     "kebabColor": "hsl(131, 70%, 50%)",
//     "fries": 123,
//     "friesColor": "hsl(126, 70%, 50%)",
//     "donut": 136,
//     "donutColor": "hsl(191, 70%, 50%)"
//   },
//   {
//     "country": "AG",
//     "hot dog": 170,
//     "hot dogColor": "hsl(321, 70%, 50%)",
//     "burger": 169,
//     "burgerColor": "hsl(333, 70%, 50%)",
//     "sandwich": 186,
//     "sandwichColor": "hsl(326, 70%, 50%)",
//     "kebab": 188,
//     "kebabColor": "hsl(101, 70%, 50%)",
//     "fries": 73,
//     "friesColor": "hsl(49, 70%, 50%)",
//     "donut": 145,
//     "donutColor": "hsl(245, 70%, 50%)"
//   },
//   {
//     "country": "AI",
//     "hot dog": 194,
//     "hot dogColor": "hsl(20, 70%, 50%)",
//     "burger": 195,
//     "burgerColor": "hsl(74, 70%, 50%)",
//     "sandwich": 14,
//     "sandwichColor": "hsl(46, 70%, 50%)",
//     "kebab": 135,
//     "kebabColor": "hsl(352, 70%, 50%)",
//     "fries": 166,
//     "friesColor": "hsl(129, 70%, 50%)",
//     "donut": 82,
//     "donutColor": "hsl(204, 70%, 50%)"
//   },
//   {
//     "country": "AL",
//     "hot dog": 200,
//     "hot dogColor": "hsl(290, 70%, 50%)",
//     "burger": 37,
//     "burgerColor": "hsl(257, 70%, 50%)",
//     "sandwich": 109,
//     "sandwichColor": "hsl(97, 70%, 50%)",
//     "kebab": 121,
//     "kebabColor": "hsl(26, 70%, 50%)",
//     "fries": 67,
//     "friesColor": "hsl(129, 70%, 50%)",
//     "donut": 5,
//     "donutColor": "hsl(197, 70%, 50%)"
//   },
//   {
//     "country": "AM",
//     "hot dog": 151,
//     "hot dogColor": "hsl(241, 70%, 50%)",
//     "burger": 103,
//     "burgerColor": "hsl(323, 70%, 50%)",
//     "sandwich": 181,
//     "sandwichColor": "hsl(95, 70%, 50%)",
//     "kebab": 87,
//     "kebabColor": "hsl(139, 70%, 50%)",
//     "fries": 197,
//     "friesColor": "hsl(348, 70%, 50%)",
//     "donut": 188,
//     "donutColor": "hsl(261, 70%, 50%)"
//   }
// ]


export const data =[
  {
    Year:2019,
    Spain:900,
    France:1400,
    Germany:1700.
  },
  {
    Year:2020,
    Spain:1000,
    France:1500,
    Germany:1800.
  },
  {
    Year:2021,
    Spain:1100,
    France:1600,
    Germany:1900.
  },
  {
    Year:2022,
    Spain:1200,
    France:1700,
    Germany:2000.
  },
]